/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const CREATE_ACTION_SHIFT = gql`
  mutation CreateActionShift($input: ActionGroupInput!) {
    createActionShift(data: $input) {
      id
      title
    }
  }
`
